@if (authService.isAuthenticated()) {
  <div class="default-layout">
    <app-sidebar></app-sidebar>

    <div class="default-container">
      <main class="default-container__content">
        <ng-content>
          <router-outlet />
        </ng-content>
      </main>
    </div>
  </div>
}
